<template>
  <v-dialog
    v-model="model"
    v-bind:content-class="userSectionClass"
    transition="dialog-bottom-transition"
    max-width="700px"
  >
    <v-sheet class="text-center">
      <v-row aling="center" justify="start" class="pa-0 ma-0">
        <v-btn @click="closeOrBack()" text class="text-none primary--text">
          {{ _getLabel("CLOSE") }}
        </v-btn>
      </v-row>
      <v-row class="ma-0 pa-0">
        <v-list style="width: 100%">
          <v-list-item
            @click="
              () => {
                whatsappContact();
                model = false;
              }
            "
          >
            <v-list-item-avatar>
              <v-avatar size="24px" tile>
                <v-icon color="#23b123">{{ mdiWhatsapp }}</v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-title class="text-left">{{
              _getLabel("USER_SECTION_CONTACT_WHATSAPP")
            }}</v-list-item-title>

            <v-list-item-action>
              <v-icon x-small color="#747678">
                {{ mdiChevronRight }}
              </v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
            @click="
              () => {
                contactUs();
                model = false;
              }
            "
          >
            <v-list-item-avatar>
              <v-avatar size="24px" tile>
                <v-icon color="primary">{{ mdiEmailOutline }}</v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-title class="text-left">{{
              _getLabel("USER_SECTION_CONTACT_US")
            }}</v-list-item-title>
            <v-list-item-action>
              <v-icon x-small color="#747678">
                {{ mdiChevronRight }}
              </v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="!comunication"></v-divider>
          <v-list-item
            v-if="!comunication"
            @click="
              () => {
                openExternalUrl({ url: _getParameter('INSTAGRAM_LINK') });
                model = false;
              }
            "
          >
            <v-list-item-avatar>
              <v-avatar size="24px" tile>
                <v-icon color="#C13584">{{ mdiInstagram }}</v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-title class="text-left">Instagram</v-list-item-title>
            <v-list-item-action>
              <v-icon x-small color="#747678">
                {{ mdiChevronRight }}
              </v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-divider
            v-if="
              !comunication &&
              (!!/android/i.test(_getUserAgent()) || _isIosWeb() || _isIos())
            "
          ></v-divider>

          <v-list-item
            v-if="/android/i.test(_getUserAgent()) && !comunication"
            @click="
              () => {
                openExternalUrl({ url: _getParameter('APP_ON_PLAY_STORE') });
                model = false;
              }
            "
          >
            <v-list-item-avatar>
              <v-avatar style="margin-left: 5px" size="24px" tile>
                <v-img
                  :src="images.PLAY_STORE"
                  :lazy-src="images.PLAY_STORE"
                ></v-img>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-title class="text-left">{{
              _getLabel("APP_ON_PLAY_STORE")
            }}</v-list-item-title>
            <v-list-item-action>
              <v-icon x-small color="#747678">
                {{ mdiChevronRight }}
              </v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-list-item
            v-if="(_isIosWeb() || _isIos()) && !comunication"
            @click="
              () => {
                openExternalUrl({ url: _getParameter('APP_ON_APPLE_STORE') });
                model = false;
              }
            "
          >
            <v-list-item-avatar>
              <v-avatar size="24px" tile>
                <v-icon color="black">{{ mdiApple }}</v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-title class="text-left">{{
              _getLabel("APP_ON_APPLE_STORE")
            }}</v-list-item-title>
            <v-list-item-action>
              <v-icon x-small color="#747678">
                {{ mdiChevronRight }}
              </v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="!comunication"></v-divider>
          <v-list-item v-if="!comunication" @click="myAccountMode = true">
            <v-list-item-avatar>
              <v-avatar size="24px" tile>
                <v-icon color="primary">{{ mdiAccountBoxOutline }}</v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-title class="text-left">{{
              _getLabel("MY_DATA")
            }}</v-list-item-title>
            <v-list-item-action>
              <v-icon x-small color="#747678">
                {{ mdiChevronRight }}
              </v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-row>
      <v-row
        v-if="!myAccountMode"
        class="ma-0 pa-0 mt-5"
        align="center"
        justify="end"
      >
        <p
          class="ma-0 term-form-app-version vetalfa-padding-bottom-notch text-right"
        >
          {{ _getParameter("APP_VERSION") }}
        </p>
      </v-row>
    </v-sheet>
    <vetalfa-dialog
      v-on:dialogClose="myAccountMode = false"
      :title="_getLabel('MY_DATA')"
      :bottom="false"
      :toggleModel="myAccountMode"
      :fullscreen="this.$vuetify.breakpoint.xsOnly"
      max-width="700px"
    >
      <v-row v-if="!editName.model" class="ma-0 pa-0">
        <v-card elevation="0" v-if="!!myAccountMode" class="mx-1" width="100%">
          <v-card-title class="mb-0 pb-0"> Olá, </v-card-title>
          <v-card-title class="my-0 py-0">
            <span v-if="!editName.model" class="font-weight-bold">{{
              user.displayName || _getLabel("NO_NAME")
            }}</span>
            <v-icon
              @click="editNameClick()"
              small
              v-if="!editName.model"
              class="ml-2 vetalfa-pointer"
              color="primary"
              >{{ mdiPencil }}</v-icon
            >
          </v-card-title>
          <v-row v-if="editName.model" class="ma-0 pa-0 pt-5">
            <v-spacer></v-spacer>
            <v-btn
              outlined
              class="text-none primary--text mr-3"
              @click="editName.model = false"
            >
              Cancelar
            </v-btn>
            <v-btn class="text-none primary mr-3" @click="stepModel -= 1">
              Salvar
            </v-btn>
          </v-row>
          <v-card-text class="text-left my-0 py-0">
            {{ user.email }}
          </v-card-text>
          <v-card-text v-if="!_isCordovaApp()" class="text-left my-0 py-0">
            {{ `Assinatura: ${!!isPremium ? "Ativa" : "Inativa"}` }}
          </v-card-text>
          <v-card-actions v-if="!_isCordovaApp()" class="px-3">
            <v-btn
              outlined
              small
              color="primary"
              @click="subscriptionsOptionClick"
            >
              {{
                `${!!isPremium ? " Gerenciar Assinatura" : "Seja Vet Alfa PRO"}`
              }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-list v-if="!!myAccountMode" style="width: 100%">
          <v-list-item @click="openQuestionsSection()">
            <v-list-item-avatar>
              <v-avatar size="24px" tile>
                <v-icon color="primary">{{
                  mdiFileDocumentEditOutline
                }}</v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-title class="text-left">{{
              _getLabel("AWNSER_QUESTIONS")
            }}</v-list-item-title>
            <v-list-item-action>
              <v-icon x-small color="#747678">
                {{ mdiChevronRight }}
              </v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
            @click="
              () => {
                openExternalUrl({
                  url: _getParameter('POLICIES_URL'),
                  inAppBrowser: true,
                });
                model = false;
              }
            "
          >
            <v-list-item-avatar>
              <v-avatar size="24px" tile>
                <v-icon color="#0e6b0e">{{ mdiShieldLock }}</v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-title class="text-left">{{
              _getLabel("PRIVACY_POLICIES_TITLE")
            }}</v-list-item-title>
            <v-list-item-action>
              <v-icon x-small color="#747678">
                {{ mdiChevronRight }}
              </v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
            @click="
              () => {
                openExternalUrl({
                  url: _getParameter('TERMS_URL'),
                  inAppBrowser: true,
                });
                model = false;
              }
            "
          >
            <v-list-item-avatar>
              <v-avatar size="24px" tile>
                <v-icon color="primary">{{ mdiTextBoxCheckOutline }}</v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-title class="text-left">{{
              _getLabel("USE_TERMS_TITLE")
            }}</v-list-item-title>
            <v-list-item-action>
              <v-icon x-small color="#747678">
                {{ mdiChevronRight }}
              </v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="deleteUser()">
            <v-list-item-avatar>
              <v-avatar size="24px" tile>
                <v-icon color="primary">{{ mdiTrashCanOutline }}</v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-title class="text-left">{{
              _getLabel("USER_EXCLUSION")
            }}</v-list-item-title>
            <v-list-item-action>
              <v-icon x-small color="#747678">
                {{ mdiChevronRight }}
              </v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
            @click="
              () => {
                confirmLogout();
                model = false;
              }
            "
          >
            <v-list-item-avatar>
              <v-avatar size="24px" tile>
                <v-icon color="primary">{{ mdiExitToApp }}</v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-title class="text-left">{{
              _getLabel("USER_SECTION_LOGOUT")
            }}</v-list-item-title>
            <v-list-item-action>
              <v-icon x-small color="#747678">
                {{ mdiChevronRight }}
              </v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-row>
      <v-row v-else align="start" class="ma-0 pa-0" style="height: 200px">
        <v-col cols="12" class="ma-0 pa-0">
          <v-card-text class="mb-0 pb-0"> Seu nome completo: </v-card-text>
        </v-col>
        <v-col cols="12" class="ma-0 pa-0">
          <v-row class="ma-0 pa-0 px-3">
            <v-text-field
              light
              dense
              color="primary"
              outlined
              clearable
              v-model="editName.value"
              counter="50"
            ></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" class="ma-0 pa-0">
          <v-row class="ma-0 pa-0 pt-5">
            <v-spacer></v-spacer>
            <v-btn
              outlined
              class="text-none primary--text mr-3"
              @click="editName.model = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              class="text-none primary mr-3"
              @click="saveUserFullNameAsync()"
            >
              Salvar
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </vetalfa-dialog>
    <vetalfa-dialog
      v-on:dialogClose="userExclusionModel = false"
      :title="_getLabel('USER_EXCLUSION')"
      :bottom="false"
      :toggleModel="userExclusionModel"
      :fullscreen="this.$vuetify.breakpoint.xsOnly"
      max-width="700px"
    >
      <v-card-text>
        <span>
          {{ _getLabel("USER_EXCLUSION_MESSAGE") }}
        </span>
        <v-checkbox
          v-model="userExclusionConfirmation"
          :label="_getLabel('USER_EXCLUSION_CHECKBOX')"
        ></v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="userExclusionModel = false">
          {{ _getLabel("USER_EXCLUSION_NO_ACTION") }}
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!userExclusionConfirmation"
          @click="deleteUserConfirmationAsync()"
        >
          {{ _getLabel("USER_EXCLUSION_YES_ACTION") }}
        </v-btn>
      </v-card-actions>
    </vetalfa-dialog>
  </v-dialog>
</template>

<style>
.term-form-app-version {
  font-size: 12px;
  padding-bottom: calc(24px + env(safe-area--top));
  padding-right: 12px;
  padding-left: 20px;
}
.term-form-text {
  font-size: 14px !important;
  text-align: justify !important;
}
</style>

<script>
import images from "@/constants/images.js";
import {
  mdiExitToApp,
  mdiShieldLock,
  mdiTextBoxCheckOutline,
  mdiEmailOutline,
  mdiWhatsapp,
  mdiAccountBoxOutline,
  mdiTrashCanOutline,
  mdiFileDocumentEditOutline,
  mdiInstagram,
  mdiApple,
  mdiStarFourPoints,
  mdiChevronRight,
  mdiPencil,
} from "@mdi/js";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "UserSection",
  components: {},
  props: {
    comunication: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    ...mapMutations("general", ["setUserSection"]),
    ...mapActions("general", [
      "openExternalUrl",
      "confirmLogout",
      "contactUs",
      "openQuestions",
      "deleteUserConfirmation",
      "saveUserFullName",
      "logEvent",
    ]),
    ...mapActions("purchases", ["openPurchases", "createCustomersPortalLink"]),
    editNameClick() {
      this.editName = {
        value: this.user.displayName,
        model: true,
      };
    },
    async saveUserFullNameAsync() {
      this.editName.model = false;
      this.myAccountMode = false;

      this.$nextTick(() => {
        this.model = false;
      });

      await this.saveUserFullName({ displayName: this.editName.value });

      this.$nextTick(() => {
        this.myAccountMode = true;
      });
    },
    clickOpenPurchases() {
      this.myAccountMode = false;
      this.$nextTick(() => {
        this.model = false;
      });
      this.openPurchases();
    },
    clickManageSubscriptions() {
      this.logEvent("purchasesManageSubscriptions");
      this.myAccountMode = false;
      this.$nextTick(() => {
        this.model = false;
      });
      this.createCustomersPortalLink();
    },
    subscriptionsOptionClick() {
      if (this.isPremium) {
        this.clickManageSubscriptions();
      } else {
        this.clickOpenPurchases();
      }
    },
    whatsappContact() {
      const url = `${
        this.$vuetify.breakpoint.xsOnly
          ? "https://wa.me/"
          : "https://web.whatsapp.com/send?phone="
      }553195506137${
        this.$vuetify.breakpoint.xsOnly ? "?" : "&"
      }text=Olá,%20equipe%20Vet%20Alfa!%20Meu%20id:%20VA-${this.user.uid.slice(
        0,
        8
      )}%20(não%20apague%20o%20id%20na%20primeira%20mensagem,%20ele%20nos%20ajuda%20a%20lhe%20proporcionar%20a%20melhor%20experiência%20de%20atendimento).`;
      this.openExternalUrl({ url });
    },
    closeOrBack() {
      if (this.myAccountMode) {
        this.myAccountMode = false;
      } else {
        this.model = false;
      }
    },
    openQuestionsSection() {
      this.openQuestions();
      this.model = false;
    },
    deleteUser() {
      this.model = false;
      this.userExclusionModel = true;
      this.userExclusionConfirmation = false;
    },
    deleteUserConfirmationAsync() {
      this.userExclusionModel = false;
      this.userExclusionConfirmation = false;
      this.model = false;
      this.deleteUserConfirmation();
    },
  },
  watch: {
    model(val) {
      if (!!val) {
        this.myAccountMode = false;
      }
    },
    myAccountMode(val) {
      this.editName.model = false;
      this.model = !val;
    },
  },
  computed: {
    ...mapGetters("general", ["userSection", "user", "isPremium"]),
    model: {
      get() {
        if (!!this.userSection["comunication"]) {
          this.comunication = !!this.userSection["comunication"];
        }
        return !!this.userSection;
      },
      set(val) {
        this.setUserSection(val);
      },
    },
    height() {
      return window.innerHeight;
    },
    userSectionClass() {
      return this.$vuetify.breakpoint.xsOnly ? "v-bottom-sheet" : "";
    },
  },
  data() {
    return {
      images,
      mdiExitToApp,
      mdiShieldLock,
      mdiTextBoxCheckOutline,
      mdiEmailOutline,
      mdiWhatsapp,
      mdiInstagram,
      mdiApple,
      mdiAccountBoxOutline,
      mdiFileDocumentEditOutline,
      mdiTrashCanOutline,
      mdiStarFourPoints,
      mdiChevronRight,
      mdiPencil,
      editName: {
        model: false,
        value: null,
      },
      myAccountMode: true,
      userExclusionModel: false,
      userExclusionConfirmation: false,
    };
  },
};
</script>